import { DownloadType } from '../../hooks/download/useDownload'
import { Constants } from '../../utils/constants'
import { Http } from '../../utils/types'
import { GetBlob, ObjectGeneric } from '../../utils/types/generals'
import { RecurrenceCreateComment } from './recurrenceBody'
import { RecurrenceByID } from './recurrenceType'
import { CloseScheduled, ScheduledById, ScheduledList, SectionScheduldeQuestionnaire, UploadScheduled, ReportUrl, DeleteScheduleInterface, ScheduleInformResponse, StoreScheduledPerformanceResponse, StoreScheduledPerformanceParams, StoreScheduledPerformancePieChartResponse, StoreScheduledPerformancePieChartParams, CriticalSectionsResponse, CriticalSectionsParams, ProcessResultResponse, ProcessStatusBaseParams, GenerateFileStoreScheduledParams, GenerateFileStoreScheduledResponse, GeneratedReportStoreScheduledResponse } from './response'
import { AppliedScheduledResponse } from './responseScheduledApplied'

export const ScheduleService = (client: Http) => ({
  list: async (data?: { query?: string }): Promise<ScheduledList> => await client.get(`scheduled-visit${data?.query ? '?' + data?.query : ''}`),
  updateSchedule: async (body: ObjectGeneric, id: number): Promise<ScheduledById> => await client.put(`scheduled-visit/${id}`, body),
  updateScheduleRecurrent: async (body: ObjectGeneric, id: number): Promise<ScheduledById> => await client.put(`scheduled-visit/recurrent-visit/${id}`, body),
  updateScheduleSerie: async (body: ObjectGeneric, id: number): Promise<ScheduledById> => await client.put(`scheduled-visit/serie/${id}`, body),
  deleteScheduleRecurrent: async (id: string) => await client.delete(`scheduled-visit/assigned-questionnaire/${id}`),
  deleteScheduleSerie: async (id: string) => await client.delete(`scheduled-visit/serie/${id}`),
  deleteScxheduleMasive: async (body: DeleteScheduleInterface,query?:string) => await client.post(`scheduled-visit/massive/delete${query ? `?${query}`:'' }`, body),
  createSchedule: async (body: ObjectGeneric): Promise<ScheduledById> => await client.post('scheduled-visit', body),
  closeSchedule: async (id: number | string): Promise<CloseScheduled> => await client.put(`scheduled-visit/close-scheduled-visit/${id}`),
  getScheduleById: async (id: number | string, questionarieId: number | string): Promise<ScheduledById> => await client.get(`scheduled-visit/list/${id}?assignedQuestionnaireId=${questionarieId}`),
  getAppliedSchedule: async (): Promise<AppliedScheduledResponse> => await client.get(`scheduled-visit/applied`),
  loadSchedule: async (body: ObjectGeneric): Promise<Response & UploadScheduled> => await client?.blob?.(`scheduled-visit/load-schedule`, body, true),
  getRegister: async (data: { type: DownloadType, query?: string }): Promise<ScheduleInformResponse> => await client.get(`scheduled-visit/generate-file?type=${data.type}${data?.query ? `${data?.query}` : ''}`),
  getQuestionarieById: async (id: number | string): Promise<Array<SectionScheduldeQuestionnaire>> => await client.get(`questionnaires/detail?assignedQuestionnaireId=${id}`),
  getRecurrenceById: async ({ id }: { id: number | string }): Promise<RecurrenceByID> => await client.get(`recurrence/${id}?is_web=true`),
  createComment: async({body}:{body: RecurrenceCreateComment}): Promise<unknown> => await client.post('recurrence/comment', body), 
  getGenerateReport: async ({ id }: { id: number | string }) : Promise<ReportUrl> => await client.get(`questionnaires/generate-report/${id}`, 'json', {signal: AbortSignal.timeout(Constants.abortTime['10min'])}),
  deleteScheduleQuestionnaire: async ({ id }: { id: number | string }) : Promise<ReportUrl> => await client.put(`questionnaires/close/${id}`),
  downloadEvidences: async (body: ObjectGeneric): Promise<Response> => await client.blob?.('evidence/download', body),
  generateSummary: async (uuid?:string): Promise<ScheduleInformResponse> => await client.get(`scheduled-visit/generated-report/${uuid}` ),
  getStoreScheduledPerformance: async (
    params: StoreScheduledPerformanceParams
  ): Promise<StoreScheduledPerformanceResponse> => {
    const parts: string[] = []
    if (params.company_id) parts.push(`company_id=${params.company_id}`)
    if (params.store_ids) parts.push(`store_ids=${params.store_ids}`)
    if (params.questionnaire_ids) parts.push(`questionnaire_ids=${params.questionnaire_ids}`)
    if (params.date_init) parts.push(`date_init=${params.date_init}`)
    if (params.date_end) parts.push(`date_end=${params.date_end}`)
    if (params.division_ids) parts.push(`division_ids=${params.division_ids}`)
    if (params.zone_ids) parts.push(`zone_ids=${params.zone_ids}`)
    if (params.user_ids) parts.push(`user_ids=${params.user_ids}`)
    if (params.role_ids) parts.push(`role_ids=${params.role_ids}`)
    if (params.year) parts.push(`year=${params.year}`)
    if (params.weeks) parts.push(`weeks=${params.weeks}`)
    const query = parts.length > 0 ? `?${parts.join('&')}` : ''
    return await client.get(`scheduled-visit/store-scheduled-performance${query}`)
  },
  getStoreScheduledPerformancePieChart: async (
    params: StoreScheduledPerformancePieChartParams
  ): Promise<StoreScheduledPerformancePieChartResponse> => {
    const parts: string[] = []
    if (params.company_id) parts.push(`company_id=${params.company_id}`)
    if (params.store_ids) parts.push(`store_ids=${params.store_ids}`)
    if (params.questionnaire_ids) parts.push(`questionnaire_ids=${params.questionnaire_ids}`)
    if (params.date_init) parts.push(`date_init=${params.date_init}`)
    if (params.date_end) parts.push(`date_end=${params.date_end}`)
    if (params.division_ids) parts.push(`division_ids=${params.division_ids}`)
    if (params.zone_ids) parts.push(`zone_ids=${params.zone_ids}`)
    if (params.user_ids) parts.push(`user_ids=${params.user_ids}`)
    if (params.role_ids) parts.push(`role_ids=${params.role_ids}`)
    if (params.year) parts.push(`year=${params.year}`)
    if (params.weeks) parts.push(`weeks=${params.weeks}`)
    if (params.page !== undefined) parts.push(`page=${params.page}`)
    if (params.size !== undefined) parts.push(`size=${params.size}`)
    const query = parts.length > 0 ? `?${parts.join('&')}` : ''
    return await client.get(`scheduled-visit/store-scheduled-performance-pie-chart${query}`)
  },
  getCriticalSections: async (
    params: CriticalSectionsParams
  ): Promise<CriticalSectionsResponse> => {
    const parts: string[] = []
    if (params.store_ids) parts.push(`store_ids=${params.store_ids}`)
    if (params.questionnaire_ids) parts.push(`questionnaire_ids=${params.questionnaire_ids}`)
    if (params.company_id) parts.push(`company_id=${params.company_id}`)
    if (params.date_init) parts.push(`date_init=${params.date_init}`)
    if (params.date_end) parts.push(`date_end=${params.date_end}`)
    if (params.year) parts.push(`year=${params.year}`)
    if (params.weeks) parts.push(`weeks=${params.weeks}`)
    if (params.division_ids) parts.push(`division_ids=${params.division_ids}`)
    if (params.zone_ids) parts.push(`zone_ids=${params.zone_ids}`)
    if (params.user_ids) parts.push(`user_ids=${params.user_ids}`)
    if (params.role_ids) parts.push(`role_ids=${params.role_ids}`)
    if (params.page !== undefined) parts.push(`page=${params.page}`)
    if (params.size !== undefined) parts.push(`size=${params.size}`)
    if (params.order) parts.push(`order=${params.order}`)
    if (params.range_critical_init != null) parts.push(`range_critical_init=${params.range_critical_init}`)
    if (params.range_critical_end != null) parts.push(`range_critical_end=${params.range_critical_end}`)
    const query = parts.length > 0 ? `?${parts.join('&')}` : ''
    return await client.get(`scheduled-visit/critical-sections${query}`)
  },
  getProcessResult: async (
    params: ProcessStatusBaseParams
  ): Promise<ProcessResultResponse> => {
    const parts: string[] = []
    if (params.store_ids) parts.push(`store_ids=${params.store_ids}`)
    if (params.questionnaire_ids) parts.push(`questionnaire_ids=${params.questionnaire_ids}`)
    if (params.company_id) parts.push(`company_id=${params.company_id}`)
    if (params.date_init) parts.push(`date_init=${params.date_init}`)
    if (params.date_end) parts.push(`date_end=${params.date_end}`)
    if (params.year) parts.push(`year=${params.year}`)
    if (params.weeks) parts.push(`weeks=${params.weeks}`)
    if (params.division_ids) parts.push(`division_ids=${params.division_ids}`)
    if (params.zone_ids) parts.push(`zone_ids=${params.zone_ids}`)
    if (params.user_ids) parts.push(`user_ids=${params.user_ids}`)
    if (params.role_ids) parts.push(`role_ids=${params.role_ids}`)
    if (params.page !== undefined) parts.push(`page=${params.page}`)
    if (params.size !== undefined) parts.push(`size=${params.size}`)
    if (params.order) parts.push(`order=${params.order}`)
    const query = parts.length > 0 ? `?${parts.join('&')}` : ''
    return await client.get(`scheduled-visit/process-result${query}`)
  },
  generateFileStoreScheduled: async (
    params: GenerateFileStoreScheduledParams
  ): Promise<GenerateFileStoreScheduledResponse> => {
    const parts: string[] = []
    if (params.company_id) parts.push(`company_id=${params.company_id}`)
    if (params.store_ids) parts.push(`store_ids=${params.store_ids}`)
    if (params.questionnaire_ids) parts.push(`questionnaire_ids=${params.questionnaire_ids}`)
    if (params.date_init) parts.push(`date_init=${params.date_init}`)
    if (params.date_end) parts.push(`date_end=${params.date_end}`)
    if (params.year) parts.push(`year=${params.year}`)
    if (params.weeks) parts.push(`weeks=${params.weeks}`)
    if (params.division_ids) parts.push(`division_ids=${params.division_ids}`)
    if (params.zone_ids) parts.push(`zone_ids=${params.zone_ids}`)
    if (params.user_ids) parts.push(`user_ids=${params.user_ids}`)
    if (params.role_ids) parts.push(`role_ids=${params.role_ids}`)
    if (params.order) parts.push(`order=${params.order}`)
    if (params.range_critical_init != null) parts.push(`range_critical_init=${params.range_critical_init}`)
    if (params.range_critical_end != null) parts.push(`range_critical_end=${params.range_critical_end}`)
    if (params.type) parts.push(`type=${params.type}`)
    const query = parts.length > 0 ? `?${parts.join('&')}` : ''
    return await client.get(`scheduled-visit/generate-file-store-scheduled${query}`)
  },
  getGeneratedReportStoreScheduled: async (
    uuid: string
  ): Promise<GeneratedReportStoreScheduledResponse> => {
    return await client.get(`scheduled-visit/generated-report-store-scheduled-ind/${uuid}`)
  },
})